var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',_vm._g(_vm._b({attrs:{"lang":_vm.lang,"name":_vm.fieldName,"format":"YYYY-MM-DD","input-class":"mx-input","popup-class":"el-date-editor .el-input__inner","value-type":_vm.dateFormat}},'date-picker',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }